import API from 'services/API/index';

export default function requestToBank(data, queryParams) {
  if (!queryParams.cardId) {
    delete queryParams.cardId;
  }

  if (!queryParams.childInn) {
    delete queryParams.childInn;
  }

  return API.request({
    method: 'POST',
    url: '/pay',
    data,
    params: { useBankFromSettings: true, ...queryParams },
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function saveNewCardParamsGPb() {
  return API.request({
    method: 'GET',
    url: '/pay/cards/save-new-card-params',
    params: { acceptedPersonalDataProcessing: true },
  });
}
